export default __webpack_public_path__ + "static/media/author@2x.b23279b9.png";